export default __webpack_public_path__ + "static/media/Art_lowerLeft.7c1db321.png";